import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';

interface Key {
  username: string;
  roleName: string;
  expirationTime: string;
  sslSerialNumber: string;
}

const User: React.FC = () => {
  const { sslSerialNumber } = useParams<{ sslSerialNumber: string }>();
  const location = useLocation() as { state: { user?: Key } };
  const [user, setUser] = useState<Key | null>(location.state?.user || null);
  const [loading, setLoading] = useState<boolean>(!location.state?.user);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!user) {
      console.log("Loading user from users list");

      const fetchConfigAndUserDetails = async () => {
        try {
          // Fetch the host configuration
          const response = await fetch('/config.json');
          const config = await response.json();
          const host = config.host;
          console.log('Host loaded from config:', host);

          // Now that we have the host, fetch the user details
          try {
            console.log("Requesting to " + host);
            const userResponse = await axios.get(`${host}/userManagement/users/${sslSerialNumber}`);
            setUser(userResponse.data);
            setLoading(false);
          } catch (err) {
            console.log("Failed to fetch user");
            setError('Failed to fetch user details.');
            setLoading(false);
          }
        } catch (error) {
          console.error('Error loading config:', error);
          setError('Error loading configuration.');
          setLoading(false);
        }
      };

      fetchConfigAndUserDetails();
    }
  }, [sslSerialNumber, user]);

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  if (error) {
    return <Typography>{error}</Typography>;
  }

  if (!user) {
    return <Typography>No user found.</Typography>;
  }

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h4" gutterBottom>
        User Details
      </Typography>
      <TextField
        label="Key Name"
        value={user.username}
        InputProps={{
          readOnly: true,
        }}
        variant="outlined"
        fullWidth
        margin="normal"
      />
      <TextField
        label="Role Name"
        value={user.roleName}
        InputProps={{
          readOnly: true,
        }}
        variant="outlined"
        fullWidth
        margin="normal"
      />
      <TextField
        label="Expiration Time"
        value={user.expirationTime}
        InputProps={{
          readOnly: true,
        }}
        variant="outlined"
        fullWidth
        margin="normal"
      />
      <TextField
        label="SSL Serial Number"
        value={user.sslSerialNumber}
        InputProps={{
          readOnly: true,
        }}
        variant="outlined"
        fullWidth
        margin="normal"
      />
    </Box>
  );
};

export default User;
